<h3 mat-dialog-title>Деактивация {{test.type === 'POLL' ? 'опроса' : 'теста'}}</h3>
<div mat-dialog-content>
  <p>Вы действительно хотите деактивировать {{test.type === 'POLL' ? 'опрос' : 'тест'}}?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button
          (click)="onCancel()">Отмена
  </button>
  <button mat-flat-button color="warn"
          cdkFocusInitial
          (click)="onSubmit()">Деактивировать
  </button>
</div>
